import { CoreShopEnvironment } from '@App/Main.types';

import { Treatment } from './types/Treatment';

export async function getTreatments(): Promise<Treatment[]> {
  const tenant = process.env.REACT_APP_CORE_SHOP_ENVIRONMENT === CoreShopEnvironment.Prod ? 'com' : 'com-qs';
  const treatments = await fetch(`/webclient/api/ods/v2/${tenant}/treatments/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(res => res.treatments);

  return <Treatment[]>treatments;
}
